export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AutocompleteResult = {
  __typename: 'AutocompleteResult';
  category_pages: Array<CategoryPage>;
  designer_name_slugs: Array<NameSlug>;
  /** @deprecated this isn't supported anymore */
  query_reformulations: Array<QueryReformulation>;
  /** @deprecated this isn't supported anymore */
  trending_queries: Array<TrendingQuery>;
  trunkshow_autocomplete_facets: Array<TrunkshowAutocompleteFacets>;
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
};


export type AutocompleteResultquery_reformulationsArgs = {
  interval?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AutocompleteResulttrending_queriesArgs = {
  interval?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum Availability {
  AVAILABLE = 'AVAILABLE',
  AVAILABLE_NOW = 'AVAILABLE_NOW',
  PREORDER = 'PREORDER',
  SOLD_OUT = 'SOLD_OUT',
  TRUNKSHOW = 'TRUNKSHOW'
}

export type AvailabilityFacet = {
  __typename: 'AvailabilityFacet';
  available_now: Scalars['Int']['output'];
  preorder: Scalars['Int']['output'];
  trunkshow: Scalars['Int']['output'];
};

export enum AvailabilityInput {
  available_now = 'available_now',
  preorder = 'preorder',
  trunkshow = 'trunkshow'
}

export type CarouselCell = Look | Slide | Trunkshow | Variant;

export type CarouselItem = {
  __typename: 'CarouselItem';
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type CarouselPumoModule = {
  __typename: 'CarouselPumoModule';
  bgColor: Scalars['String']['output'];
  cells: Array<CarouselCell>;
  editorials: Maybe<Array<Editorial>>;
  id: Scalars['Int']['output'];
  /** top: 0, right: 1, bottom: 2, left: 3 */
  imageEditorialPosition: Maybe<Scalars['Int']['output']>;
  layoutType: Maybe<Scalars['Int']['output']>;
  looks: Maybe<Array<CarouselItem>>;
  mainEditorial: Maybe<Slide>;
  modelId: Scalars['String']['output'];
  moduleHeight: Maybe<Scalars['String']['output']>;
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  products: Maybe<Array<CarouselItem>>;
  trunkshows: Maybe<Array<CarouselItem>>;
};

export type CategoryPage = {
  __typename: 'CategoryPage';
  attribute: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subcategory: Scalars['String']['output'];
};

export type CategoryTree = {
  __typename: 'CategoryTree';
  children: Maybe<Array<Maybe<CategoryTree>>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  total_items: Scalars['Int']['output'];
};

export type CollectionInput = {
  attribute_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availability?: InputMaybe<Array<InputMaybe<AvailabilityInput>>>;
  availability_enum?: InputMaybe<Array<Availability>>;
  category_path?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  designers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Algolia Dynamic Re-Ranking */
  dynamic_reranking?: InputMaybe<Scalars['Boolean']['input']>;
  filter_colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gift_category_path?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  no_sale?: InputMaybe<Scalars['Boolean']['input']>;
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Applies raw Algolia optionalFilters directly, bypassing Rules — for instant preview of unpublished changes */
  optional_filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_range?: InputMaybe<PriceRange>;
  primary_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Same as `attributes`, but has a higher precedence.
   * More specifically:
   * - `primary_attributes` and `attributes` are joined with AND, while values inside these 2 buckets are joined with OR.
   * - The facets for `attributes` are filtered by `primary_attributes` while the opposite is not true.
   */
  q?: InputMaybe<Scalars['String']['input']>;
  rounded_markdown_percentages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overwrites the rule contexts sent to Algolia */
  rule_contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allows previewing of unpublished rules */
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  /**
   * sale: true - returns only items on sale
   * sale: false - returns only items NOT on sale
   * sale: null - returns all items (both on sale and not on sale)
   */
  sale?: InputMaybe<Scalars['Boolean']['input']>;
  sale_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoring?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionResult = {
  __typename: 'CollectionResult';
  applied_filters: Array<Scalars['String']['output']>;
  attributes: Array<NameSlugFacet>;
  availability: AvailabilityFacet;
  category_tree: CategoryTree;
  collections: Array<Facet>;
  designers: Array<NameSlugFacet>;
  designers_with_id: Array<NameSlugIdFacet>;
  filter_colors: Array<Facet>;
  materials: Array<NameSlugFacet>;
  page_name: Scalars['String']['output'];
  /** @deprecated this contains the same values as the price_range input */
  price_range: PriceRangeInfo;
  primary_attributes: Array<NameSlugFacet>;
  redirect_url: Maybe<Scalars['String']['output']>;
  rounded_markdown_percentages: Array<Facet>;
  sale_tags: Array<Facet>;
  seasons: Array<Facet>;
  /**
   * Same as `attributes`, but has a higher precedence.
   * The facets for `attributes` are filtered by `primary_attributes` while the opposite is not true.
   */
  sizes: Array<SizeFacet>;
  subcategories: Array<Facet>;
  tags: Array<Facet>;
  total_items: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  variants: VariantConnection;
};


export type CollectionResultvariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sort_enum?: InputMaybe<CollectionSort>;
};

export enum CollectionSort {
  DEFAULT = 'DEFAULT',
  HIGH = 'HIGH',
  INVENTORY = 'INVENTORY',
  LOW = 'LOW',
  MARKDOWN = 'MARKDOWN',
  RECENCY = 'RECENCY',
  RECENCY_NEW = 'RECENCY_NEW'
}

export type Condition = {
  alternatives?: InputMaybe<Scalars['Boolean']['input']>;
  anchoring?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};

export type Consequence = {
  filterPromotes?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<RuleParams>;
  promote: Array<RulePromote>;
};

export type Cookies = {
  __typename: 'Cookies';
  cartId: Maybe<Scalars['String']['output']>;
  cloudfrontViewerCountry: Maybe<Scalars['String']['output']>;
  fullUser: Scalars['String']['output'];
  isAmexCustomer: Maybe<Scalars['String']['output']>;
  modaAnonymousId: Maybe<Scalars['String']['output']>;
  preferences: Scalars['String']['output'];
  promoCode: Maybe<Scalars['String']['output']>;
  sessionQueryParams: Maybe<Scalars['String']['output']>;
  signifydSessionId: Maybe<Scalars['String']['output']>;
  stateAbbreviation: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export enum CtaType {
  BUTTON = 'BUTTON',
  LINK = 'LINK'
}

export type CustomizationParameters = {
  __typename: 'CustomizationParameters';
  character_class: Scalars['String']['output'];
  display_text: Scalars['String']['output'];
  max_length: Scalars['Int']['output'];
  min_length: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
};

export type Designer = {
  __typename: 'Designer';
  description: Scalars['String']['output'];
  /** @deprecated use name and/or slug instead */
  designer_name_slug: Scalars['String']['output'];
  /** @deprecated construct the href from the slug instead */
  href: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectid: Scalars['String']['output'];
  queryid: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
};

export type DesktopNavigatorItem = {
  __typename: 'DesktopNavigatorItem';
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  style: NavigatorItemStyle;
  units: Array<DesktopNavigatorUnit>;
};

export type DesktopNavigatorUnit = EditorialNavigatorUnit | ListNavigatorUnit;

export type DesktopNavigatorVertical = {
  __typename: 'DesktopNavigatorVertical';
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  index: Scalars['String']['output'];
  items: Array<DesktopNavigatorItem>;
  style: NavigatorItemStyle;
  title: Scalars['String']['output'];
};

export type DisplayPage = {
  __typename: 'DisplayPage';
  guideSubPages: Maybe<Array<GuideSubPage>>;
  /** @deprecated this is no longer supported */
  looks: Array<Array<Scalars['Int']['output']>>;
  meta_description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  page_title: Scalars['String']['output'];
  /** @deprecated this is no longer supported */
  products: Array<Array<Scalars['Int']['output']>>;
  restricted_to_user_groups: Array<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  targetBuckets: Array<TargetBucket>;
  /** @deprecated this is no longer supported */
  trunkshows: Array<Array<Scalars['Int']['output']>>;
  versionId: Scalars['Int']['output'];
};

export type DividerPumoModule = {
  __typename: 'DividerPumoModule';
  bgColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  layoutType: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  verticalPadding: Maybe<Scalars['String']['output']>;
};

export type Editorial = {
  __typename: 'Editorial';
  afterId: Maybe<Scalars['Int']['output']>;
  afterPosition: Maybe<Scalars['Int']['output']>;
  editorialId: Maybe<Scalars['String']['output']>;
  slides: Array<Slide>;
};

export type EditorialNavigatorUnit = {
  __typename: 'EditorialNavigatorUnit';
  anchorText: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  href: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image_alt: Scalars['String']['output'];
  image_source: Scalars['String']['output'];
};

export type EditorialVideo = {
  __typename: 'EditorialVideo';
  has_audio: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  mobile_has_audio: Maybe<Scalars['Boolean']['output']>;
  mobile_height: Maybe<Scalars['Int']['output']>;
  mobile_id: Maybe<Scalars['String']['output']>;
  mobile_width: Maybe<Scalars['Int']['output']>;
  placement: EditorialVideoPlacement;
  width: Maybe<Scalars['Int']['output']>;
};

export enum EditorialVideoPlacement {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export type EmailPumoModule = {
  __typename: 'EmailPumoModule';
  bgColor: Scalars['String']['output'];
  emailUnit: EmailUnit;
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slideUnit: Slide;
};

export type EmailUnit = {
  __typename: 'EmailUnit';
  backgroundColor: Maybe<Scalars['String']['output']>;
  backgroundWidth: Maybe<Scalars['Int']['output']>;
  ctaText: Maybe<Scalars['String']['output']>;
  ctaUrl: Maybe<Scalars['String']['output']>;
  desktopImage: Image;
  eyebrowText: Maybe<TextObject>;
  genderType: Maybe<GenderType>;
  headlineText: Maybe<TextObject>;
  horizontalPadding: Maybe<Scalars['Int']['output']>;
  mobileImage: Maybe<Image>;
  taglineText: Maybe<TextObject>;
  textAlignment: Maybe<Scalars['Int']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
  useDivider: Maybe<Scalars['Boolean']['output']>;
  verticalPadding: Maybe<Scalars['Int']['output']>;
};

export type ErrorModal = {
  __typename: 'ErrorModal';
  message: Maybe<Scalars['String']['output']>;
  show: Scalars['Boolean']['output'];
};

export type Facet = {
  __typename: 'Facet';
  name: Scalars['String']['output'];
  total_items: Scalars['Int']['output'];
};

export type FitRecommendation = {
  __typename: 'FitRecommendation';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FromToTimestamp = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum FulfilmentType {
  CONSIGNMENT = 'CONSIGNMENT',
  DIRECT_TO_CONSUMER = 'DIRECT_TO_CONSUMER',
  DROPSHIP = 'DROPSHIP',
  EMPLOYEE = 'EMPLOYEE',
  FULFILLMENT = 'FULFILLMENT',
  MIRAKL_DROPSHIP = 'MIRAKL_DROPSHIP',
  MIRAKL_ECONCESSION = 'MIRAKL_ECONCESSION',
  NONE = 'NONE',
  ON_ORDER = 'ON_ORDER',
  SHIPPED = 'SHIPPED',
  VINTAGE = 'VINTAGE'
}

export enum Gender {
  women = 'women'
}

export enum GenderType {
  Both = 'Both',
  Menswear = 'Menswear',
  Womenswear = 'Womenswear'
}

export type GiftCategory = {
  __typename: 'GiftCategory';
  children: Array<GiftCategory>;
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GridPumoModule = {
  __typename: 'GridPumoModule';
  bgColor: Scalars['String']['output'];
  editorials: Maybe<Array<Editorial>>;
  header: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  subheader: Scalars['String']['output'];
};

export type GuideSubPage = {
  __typename: 'GuideSubPage';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type HomePageHeaderPumoModule = {
  __typename: 'HomePageHeaderPumoModule';
  bgColor: Maybe<Scalars['String']['output']>;
  headerText: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  layoutType: Maybe<Scalars['Int']['output']>;
  list: Array<HomePageHeaderPumoModuleListItem>;
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slides: Array<Slide>;
};

export type HomePageHeaderPumoModuleListItem = {
  __typename: 'HomePageHeaderPumoModuleListItem';
  anchorText: Maybe<TextObject>;
  ctaUrl: Maybe<Scalars['String']['output']>;
  featureImage: Maybe<Image>;
  headlineText: Maybe<TextObject>;
};

export type Image = {
  __typename: 'Image';
  altText: Maybe<Scalars['String']['output']>;
  fullPath: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
  imagePadding: Scalars['Float']['output'];
};

export type Inventory = {
  __typename: 'Inventory';
  available: Scalars['Int']['output'];
  can_sell: Scalars['Boolean']['output'];
  filtered_by_this_size: Scalars['Boolean']['output'];
  on_hand: Scalars['Int']['output'];
  on_order: Scalars['Int']['output'];
  process_delivery_dates: VariantDelivery;
  size: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

/** This is deprecated, use CollectionInput instead */
export type KeywordSearchInput = {
  attribute_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availability?: InputMaybe<Array<InputMaybe<AvailabilityInput>>>;
  availability_enum?: InputMaybe<Array<Availability>>;
  category_path?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  designers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Algolia Dynamic Re-Ranking */
  dynamic_reranking?: InputMaybe<Scalars['Boolean']['input']>;
  filter_colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  materials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  no_sale?: InputMaybe<Scalars['Boolean']['input']>;
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Applies raw Algolia optionalFilters directly, bypassing Rules — for instant preview of unpublished changes */
  optional_filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_range?: InputMaybe<PriceRange>;
  primary_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Same as `attributes`, but has a higher precedence.
   * More specifically:
   * - `primary_attributes` and `attributes` are joined with AND, while values inside these 2 buckets are joined with OR.
   * - The facets for `attributes` are filtered by `primary_attributes` while the opposite is not true.
   */
  q?: InputMaybe<Scalars['String']['input']>;
  rounded_markdown_percentages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overwrites the rule contexts sent to Algolia */
  rule_contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allows previewing of unpublished rules */
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  /**
   * sale: true - returns only items on sale
   * sale: false - returns only items NOT on sale
   * sale: null - returns all items (both on sale and not on sale)
   */
  sale?: InputMaybe<Scalars['Boolean']['input']>;
  sale_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoring?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitedTrunkshowData = {
  __typename: 'LimitedTrunkshowData';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  season: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ListNavigatorUnit = {
  __typename: 'ListNavigatorUnit';
  header: Scalars['String']['output'];
  id: Scalars['String']['output'];
  list: Array<NavigatorUnitListItem>;
};

export type LivestreamPumoModule = {
  __typename: 'LivestreamPumoModule';
  before_cta_url: Scalars['String']['output'];
  cta_after_show_text: Scalars['String']['output'];
  cta_before_show_text: Scalars['String']['output'];
  headline_body: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  livestream_id: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slides: Array<Slide>;
  start_date: Scalars['String']['output'];
};

export type Look = {
  __typename: 'Look';
  countdown_message: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  designer_names: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['String']['output'];
  /** @deprecated use look_type_enum instead */
  look_type: Maybe<LookType>;
  look_type_enum: Maybe<LookTypeV2>;
  name: Scalars['String']['output'];
  next_look_id: Scalars['Int']['output'];
  objectid: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  previous_look_id: Scalars['Int']['output'];
  primary_image_urls: LookImageUrls;
  primary_product_id: Maybe<Scalars['Int']['output']>;
  queryid: Scalars['String']['output'];
  /** @deprecated use primary_image_urls instead */
  runway_image_urls: LookImageUrls;
  title: Maybe<Scalars['String']['output']>;
  trunkshow: Maybe<Trunkshow>;
  /** @deprecated use trunkshow instead to check expiration status */
  trunkshow_expired: Maybe<Scalars['String']['output']>;
  trunkshow_id: Maybe<Scalars['Int']['output']>;
  trunkshow_name: Scalars['String']['output'];
  trunkshow_slugs: Array<Scalars['String']['output']>;
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
  variant_ids: Array<Scalars['Int']['output']>;
  variants: VariantConnection;
};


export type LookvariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type LookConnection = {
  __typename: 'LookConnection';
  /** @deprecated use looks instead */
  edges: Array<LookEdge>;
  looks: Array<Maybe<Look>>;
  /** @deprecated use pagination instead */
  pageInfo: PageInfo;
  pagination: PaginationInfo;
};

export type LookEdge = {
  __typename: 'LookEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Look>;
};

export type LookImageUrls = {
  __typename: 'LookImageUrls';
  main: Scalars['String']['output'];
  medium_low: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export enum LookType {
  complete_the_collection = 'complete_the_collection',
  complete_the_routine = 'complete_the_routine',
  how_to_wear_it = 'how_to_wear_it',
  works_well_with = 'works_well_with'
}

export enum LookTypeV2 {
  COMPLETE_THE_COLLECTION = 'COMPLETE_THE_COLLECTION',
  COMPLETE_THE_ROUTINE = 'COMPLETE_THE_ROUTINE',
  HOW_TO_WEAR_IT = 'HOW_TO_WEAR_IT',
  WORKS_WELL_WITH = 'WORKS_WELL_WITH'
}

export type MobileNavigatorItem = {
  __typename: 'MobileNavigatorItem';
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  style: NavigatorItemStyle;
  units: Array<ListNavigatorUnit>;
};

export type MobileNavigatorVertical = {
  __typename: 'MobileNavigatorVertical';
  featured: Array<MobileNavigatorVerticalFeaturedItem>;
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  index: Scalars['String']['output'];
  items: Array<MobileNavigatorItem>;
  title: Scalars['String']['output'];
};

export type MobileNavigatorVerticalFeaturedItem = {
  __typename: 'MobileNavigatorVerticalFeaturedItem';
  anchorText: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  imageAlt: Maybe<Scalars['String']['output']>;
  imageSrc: Maybe<Scalars['String']['output']>;
};

export type MultiPumoModule = {
  __typename: 'MultiPumoModule';
  bgColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  layoutType: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['String']['output'];
  moduleHeight: Maybe<Scalars['String']['output']>;
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  units: Array<Slide>;
};

export type NameSlug = {
  __typename: 'NameSlug';
  gender_slug: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type NameSlugFacet = {
  __typename: 'NameSlugFacet';
  /** @deprecated use slug instead */
  filter_value: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  total_items: Scalars['Int']['output'];
};

export type NameSlugId = {
  __typename: 'NameSlugId';
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type NameSlugIdFacet = {
  __typename: 'NameSlugIdFacet';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  total_items: Scalars['Int']['output'];
};

export type NavigatorItemStyle = {
  __typename: 'NavigatorItemStyle';
  bold: Scalars['Boolean']['output'];
  color: Maybe<Scalars['String']['output']>;
};

export enum NavigatorPlatform {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE'
}

export type NavigatorUnitListItem = {
  __typename: 'NavigatorUnitListItem';
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: NavigatorUnitListItemType;
};

export enum NavigatorUnitListItemType {
  Default = 'Default',
  Section = 'Section'
}

export type NavigatorVertical = DesktopNavigatorVertical | MobileNavigatorVertical;

export type NewTrunkshowPage = {
  __typename: 'NewTrunkshowPage';
  looks: Maybe<Array<Maybe<TrunkshowLook>>>;
  products: Maybe<Array<Maybe<TrunkshowProduct>>>;
  trunkshow: Maybe<Trunkshow>;
};


export type NewTrunkshowPagelooksArgs = {
  optional_filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rule_contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
};


export type NewTrunkshowPageproductsArgs = {
  optional_filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rule_contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
};

export type Notification = {
  __typename: 'Notification';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationInfo = {
  __typename: 'PaginationInfo';
  page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total_entries: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaymentError = {
  __typename: 'PaymentError';
  error: Maybe<Scalars['String']['output']>;
};

export type Pill = {
  __typename: 'Pill';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PillsPumoModule = {
  __typename: 'PillsPumoModule';
  bgColor: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pills: Array<Pill>;
  platform: Array<Scalars['String']['output']>;
};

export type PriceDetails = {
  __typename: 'PriceDetails';
  currency: Scalars['String']['output'];
  currency_html_code: Scalars['String']['output'];
  human: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
};

export type PriceRange = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceRangeInfo = {
  __typename: 'PriceRangeInfo';
  max: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
  without_vat: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductListingSection {
  DESIGNER = 'DESIGNER',
  EMPLOYEE = 'EMPLOYEE',
  FAVORITES = 'FAVORITES',
  GIFTS = 'GIFTS',
  GUIDE = 'GUIDE',
  NEW = 'NEW',
  SALE = 'SALE',
  SEARCH = 'SEARCH',
  SHOP = 'SHOP',
  SHOP_BY_VARIANTS = 'SHOP_BY_VARIANTS'
}

export type PumoModule = CarouselPumoModule | DividerPumoModule | EmailPumoModule | GridPumoModule | HomePageHeaderPumoModule | LivestreamPumoModule | MultiPumoModule | PillsPumoModule | RecommendationsPumoModule | SinglePumoModule | SmsPumoModule | TrunkshowCountdownPumoModule | VideoPumoModule;

export type Query = {
  __typename: 'Query';
  autocomplete: Maybe<AutocompleteResult>;
  bought_together: Array<Maybe<Variant>>;
  cookies: Maybe<Cookies>;
  designer: Maybe<Designer>;
  /** @deprecated use product_listing instead */
  designer_collection: CollectionResult;
  designers: Array<Maybe<Designer>>;
  designers_az: CollectionResult;
  /** @deprecated this is no longer maintained, we will have a new query soon for CMS pages */
  displayPage: Maybe<DisplayPage>;
  editorial_slides: Array<Maybe<Slide>>;
  /** @deprecated use product_listing instead */
  employee: CollectionResult;
  errorModal: Maybe<ErrorModal>;
  /** @deprecated use product_listing instead */
  favorites: CollectionResult;
  gift_categories: Array<GiftCategory>;
  /** @deprecated use product_listing instead */
  guide: CollectionResult;
  /** @deprecated use product_listing instead */
  guide_page: CollectionResult;
  look: Maybe<Look>;
  looking_similar: Array<Maybe<Variant>>;
  looks: Array<Maybe<Look>>;
  navigator_verticals: Array<NavigatorVertical>;
  /** @deprecated use product_listing instead */
  new: CollectionResult;
  new_trunkshow_page: Maybe<NewTrunkshowPage>;
  notifications: Array<Notification>;
  paymentError: Maybe<PaymentError>;
  product_listing: CollectionResult;
  related_products: Array<Maybe<Variant>>;
  /** @deprecated use product_listing instead */
  sale: CollectionResult;
  /** @deprecated use product_listing instead */
  search: CollectionResult;
  /** @deprecated use product_listing instead */
  shop: CollectionResult;
  /** @deprecated use product_listing instead */
  shop_by_variants: CollectionResult;
  trending_facets_value: Array<Maybe<TrendingFacet>>;
  trending_items: Array<Maybe<Variant>>;
  trunkshow: Maybe<Trunkshow>;
  /** @deprecated this is no longer maintained, we will have a new query soon for CMS pages */
  trunkshowPage: Maybe<TrunkshowPage>;
  trunkshows: Maybe<TrunkshowCollectionResult>;
  trunkshows_by_date: Array<Maybe<Trunkshow>>;
  trunkshows_by_id: Array<Maybe<Trunkshow>>;
  usage_stats: Array<UsageStat>;
  user: Maybe<User>;
  user_token: Maybe<Scalars['String']['output']>;
  variant: Maybe<Variant>;
  variants: Array<Maybe<Variant>>;
  version: Scalars['Int']['output'];
};


export type QueryautocompleteArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type Querybought_togetherArgs = {
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  max_recommendations?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  variant_id: Scalars['String']['input'];
};


export type QuerydesignerArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type Querydesigner_collectionArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydesignersArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vertical?: InputMaybe<Vertical>;
};


export type Querydesigners_azArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type QuerydisplayPageArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  rule_suffix?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  show_beauty?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<Scalars['Boolean']['input']>;
  version_id?: InputMaybe<Scalars['Int']['input']>;
};


export type Queryeditorial_slidesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryemployeeArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type QueryfavoritesArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type Querygift_categoriesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  get_all_subcategories?: InputMaybe<Scalars['Boolean']['input']>;
  sale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryguideArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type Queryguide_pageArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
  slug: Scalars['String']['input'];
};


export type QuerylookArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type Querylooking_similarArgs = {
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  max_recommendations?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  variant_id: Scalars['String']['input'];
};


export type QuerylooksArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Querynavigator_verticalsArgs = {
  platform: NavigatorPlatform;
};


export type QuerynewArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type Querynew_trunkshow_pageArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type Queryproduct_listingArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
  section?: InputMaybe<Scalars['String']['input']>;
  section_enum?: InputMaybe<ProductListingSection>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type Queryrelated_productsArgs = {
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  max_recommendations?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  variant_id: Scalars['String']['input'];
};


export type QuerysaleArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type QuerysearchArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<KeywordSearchInput>;
};


export type QueryshopArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type Queryshop_by_variantsArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CollectionInput>;
};


export type Querytrending_facets_valueArgs = {
  facet_name: Scalars['String']['input'];
  max_recommendations?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};


export type Querytrending_itemsArgs = {
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  facet_name?: InputMaybe<Scalars['String']['input']>;
  facet_value?: InputMaybe<Scalars['String']['input']>;
  max_recommendations?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerytrunkshowArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerytrunkshowPageArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  rule_suffix?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  version_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerytrunkshowsArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<TrunkshowCollectionInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type Querytrunkshows_by_dateArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  end_dates?: InputMaybe<FromToTimestamp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start_dates?: InputMaybe<FromToTimestamp>;
};


export type Querytrunkshows_by_idArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Queryusage_statsArgs = {
  token: Scalars['String']['input'];
};


export type QueryvariantArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryvariantsArgs = {
  ab_tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  client_country_code?: InputMaybe<Scalars['String']['input']>;
  hrefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReformulation = {
  __typename: 'QueryReformulation';
  days: Scalars['Int']['output'];
  query: Scalars['String']['output'];
};

export type RecommendationsPumoModule = {
  __typename: 'RecommendationsPumoModule';
  affinityType: Maybe<Scalars['String']['output']>;
  algorithm: Maybe<Scalars['String']['output']>;
  dividerPadding: Maybe<Scalars['String']['output']>;
  dividerText: Maybe<Scalars['String']['output']>;
  dividerType: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  layoutType: Maybe<Scalars['Int']['output']>;
  limit: Maybe<Scalars['Int']['output']>;
  modelId: Scalars['String']['output'];
  moduleHeight: Maybe<Scalars['String']['output']>;
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
};

export enum ReturnPolicy {
  extended_holidays = 'extended_holidays',
  final_sale = 'final_sale',
  full_refund = 'full_refund',
  full_refund_markdown = 'full_refund_markdown',
  full_refund_no_credit = 'full_refund_no_credit',
  site_credit = 'site_credit',
  site_credit_markdown = 'site_credit_markdown'
}

export enum ReturnPolicyV2 {
  EXTENDED_HOLIDAYS = 'EXTENDED_HOLIDAYS',
  FINAL_SALE = 'FINAL_SALE',
  FULL_REFUND = 'FULL_REFUND',
  FULL_REFUND_MARKDOWN = 'FULL_REFUND_MARKDOWN',
  FULL_REFUND_NO_CREDIT = 'FULL_REFUND_NO_CREDIT',
  SITE_CREDIT = 'SITE_CREDIT',
  SITE_CREDIT_MARKDOWN = 'SITE_CREDIT_MARKDOWN'
}

export type Rule = {
  conditions: Array<Condition>;
  consequence?: InputMaybe<Consequence>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  objectID: Scalars['String']['input'];
};

export type RuleParams = {
  filters?: InputMaybe<Scalars['String']['input']>;
  optionalFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RulePromote = {
  objectIDs: Array<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export type SinglePumoModule = {
  __typename: 'SinglePumoModule';
  bgColor: Scalars['String']['output'];
  fullBleed: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  sliderAutoplay: Maybe<Scalars['Boolean']['output']>;
  slides: Array<Slide>;
};

export type SizeFacet = {
  __typename: 'SizeFacet';
  category: Maybe<Scalars['String']['output']>;
  filter_value: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['String']['output']>;
  total_items: Maybe<Scalars['Int']['output']>;
};

export type Slide = {
  __typename: 'Slide';
  ctaType: CtaType;
  ctaUrl: Maybe<Scalars['String']['output']>;
  featureImage: Maybe<Image>;
  id: Scalars['ID']['output'];
  mobileImage: Maybe<Image>;
  slideText: Maybe<SlideText>;
};

export type SlideText = {
  __typename: 'SlideText';
  anchorText: Maybe<TextObject>;
  ctaText: Maybe<Scalars['String']['output']>;
  editorialBgColor: Scalars['String']['output'];
  editorialEdgeMargin: Scalars['Int']['output'];
  editorialPosition: Scalars['String']['output'];
  editorialWidth: Scalars['Int']['output'];
  eyebrowText: Maybe<TextObject>;
  headlineText: Maybe<TextObject>;
  horizontalPadding: Scalars['Int']['output'];
  taglineText: Maybe<TextObject>;
  textAlign: TextAlignType;
  textColor: Scalars['String']['output'];
  useDivider: Scalars['Boolean']['output'];
  verticalPadding: Scalars['Int']['output'];
};

export type SmsPumoModule = {
  __typename: 'SmsPumoModule';
  body_text: Scalars['String']['output'];
  headline_text: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slides: Array<Slide>;
};

export type TargetBucket = {
  __typename: 'TargetBucket';
  modules: Array<PumoModule>;
  name: Scalars['String']['output'];
};

export enum TextAlignType {
  center = 'center',
  left = 'left',
  right = 'right'
}

export type TextObject = {
  __typename: 'TextObject';
  body: Maybe<Scalars['String']['output']>;
  bold: Maybe<Scalars['Boolean']['output']>;
  italic: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type TrendingFacet = {
  __typename: 'TrendingFacet';
  facet_name: Maybe<Scalars['String']['output']>;
  facet_value: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

export type TrendingQuery = {
  __typename: 'TrendingQuery';
  days: Scalars['Int']['output'];
  destination_path: Scalars['String']['output'];
  query: Scalars['String']['output'];
  query_type: Scalars['String']['output'];
};

export type Trunkshow = {
  __typename: 'Trunkshow';
  active_end_i: Scalars['Int']['output'];
  active_for: TrunkshowActiveFor;
  /** @deprecated use active_for instead */
  active_for_groups: Array<Scalars['Int']['output']>;
  active_start_i: Scalars['Int']['output'];
  categories: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  designer_names: Array<Scalars['String']['output']>;
  designer_slugs: Array<Scalars['String']['output']>;
  ending_image_urls: TrunkshowImageUrls;
  id: Scalars['ID']['output'];
  index: Scalars['String']['output'];
  limited_designer_data: Array<NameSlugId>;
  look_count: Scalars['Int']['output'];
  look_ids: Array<Scalars['Int']['output']>;
  looks: LookConnection;
  name: Scalars['String']['output'];
  objectid: Scalars['String']['output'];
  page_type_slugs: Array<Scalars['String']['output']>;
  preview_image_urls: Array<Scalars['String']['output']>;
  primary_image_urls: TrunkshowImageUrls;
  private_until_i: Scalars['Int']['output'];
  queryid: Scalars['String']['output'];
  restricted: Scalars['Boolean']['output'];
  season: Scalars['String']['output'];
  season_name: Scalars['String']['output'];
  secondary_image_urls: TrunkshowImageUrls;
  slug: Scalars['String']['output'];
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
  variant_ids: Array<Scalars['Int']['output']>;
  variants: VariantConnection;
};


export type TrunkshowlooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type TrunkshowvariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type TrunkshowActiveFor = {
  __typename: 'TrunkshowActiveFor';
  designer_ids: Array<Scalars['Int']['output']>;
  group_ids: Array<Scalars['Int']['output']>;
};

export type TrunkshowAutocompleteFacets = {
  __typename: 'TrunkshowAutocompleteFacets';
  active_end_i: Scalars['Int']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  private_until: Scalars['Int']['output'];
  season: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type TrunkshowCollectionInput = {
  /** List of categories to filter by, e.g. ["Clothing", "Bags"] */
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Designer ids to filter and sort by, e.g. ["3391", "317"] */
  designer_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Designer slugs to filter by, e.g. ["alexis","louis-vuitton"] */
  designer_slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of categories to exclude, e.g. ["Clothing", "Bags"] */
  excluded_categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Vertical to filter by */
  gender?: InputMaybe<Gender>;
  /** Applies raw Algolia optionalFilters directly, bypassing Rules — for instant preview of unpublished changes */
  optional_filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overwrites the rule contexts sent to Algolia */
  rule_contexts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allows previewing of unpublished rules */
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  /** Return only single designer trunkshows */
  single_designer_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional version id from Pumo */
  version_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TrunkshowCollectionResult = {
  __typename: 'TrunkshowCollectionResult';
  categories: Array<NameSlugFacet>;
  designers: Array<NameSlugFacet>;
  total_items: Scalars['Int']['output'];
  trunkshows: TrunkshowConnection;
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
};


export type TrunkshowCollectionResulttrunkshowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sort_enum?: InputMaybe<TrunkshowCollectionSort>;
};

export enum TrunkshowCollectionSort {
  ACTIVE_END = 'ACTIVE_END',
  ACTIVE_START = 'ACTIVE_START',
  DEFAULT = 'DEFAULT',
  NAME = 'NAME'
}

export type TrunkshowConnection = {
  __typename: 'TrunkshowConnection';
  /** @deprecated use trunkshows instead */
  edges: Array<TrunkshowEdge>;
  /** @deprecated use pagination instead */
  pageInfo: PageInfo;
  pagination: PaginationInfo;
  trunkshows: Array<Maybe<Trunkshow>>;
};

export type TrunkshowCountdownPumoModule = {
  __typename: 'TrunkshowCountdownPumoModule';
  bgColor: Scalars['String']['output'];
  countdownColor: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  moduleType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slide: Slide;
  trunkshow: Maybe<Trunkshow>;
};

export type TrunkshowEdge = {
  __typename: 'TrunkshowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Trunkshow>;
};

export type TrunkshowImageUrls = {
  __typename: 'TrunkshowImageUrls';
  main: Scalars['String']['output'];
  medium_low: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export type TrunkshowLook = Look | Slide;

export type TrunkshowPage = {
  __typename: 'TrunkshowPage';
  displayPage: Maybe<DisplayPage>;
  trunkshow: Maybe<Trunkshow>;
};

export type TrunkshowProduct = Slide | Variant;

export type UsageStat = {
  __typename: 'UsageStat';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type User = {
  __typename: 'User';
  accessToken: Maybe<Scalars['String']['output']>;
  affiliate: Maybe<Scalars['Int']['output']>;
  clientTier: Maybe<Scalars['Int']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isAmazonConnected: Maybe<Scalars['Boolean']['output']>;
  isLoggedIn: Scalars['Boolean']['output'];
  isMember: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  modaPrivate: Maybe<Scalars['Boolean']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  statusLevel: Maybe<Scalars['Int']['output']>;
  userLoyaltyStatus: Maybe<Scalars['Int']['output']>;
};

export type Variant = {
  __typename: 'Variant';
  active_end_i: Scalars['Int']['output'];
  active_for_groups: Array<Scalars['Int']['output']>;
  active_start_i: Scalars['Int']['output'];
  /** @deprecated use availability_enum instead */
  availability: Scalars['String']['output'];
  availability_enum: Availability;
  available: Scalars['Boolean']['output'];
  average_order_value_bucket: Scalars['Int']['output'];
  calculated_sell_through: Scalars['Float']['output'];
  calculated_sell_through_all_time: Scalars['Float']['output'];
  can_sell: Scalars['Boolean']['output'];
  category: Array<Scalars['String']['output']>;
  clinical_studies: Maybe<Scalars['String']['output']>;
  collections: Array<Scalars['String']['output']>;
  /** @deprecated use master_variants_data instead */
  current_variants_data: VariantData;
  customer_delivery_notes: Maybe<Scalars['String']['output']>;
  customizable: Scalars['Boolean']['output'];
  customization_parameters: Maybe<CustomizationParameters>;
  description: Scalars['String']['output'];
  description_text: Scalars['String']['output'];
  designer_name: Scalars['String']['output'];
  designer_slug: Scalars['String']['output'];
  detail_bullets: Maybe<Scalars['String']['output']>;
  disable_size_mapping: Scalars['Boolean']['output'];
  fit_brand: Scalars['String']['output'];
  fit_recommendation: Maybe<FitRecommendation>;
  /** @deprecated use fulfilment_type_enum instead */
  fulfilment_type: Scalars['Int']['output'];
  fulfilment_type_enum: FulfilmentType;
  /** @deprecated use vertical instead */
  gender: Scalars['Int']['output'];
  how_to_use: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['String']['output'];
  ingredients: Maybe<Scalars['String']['output']>;
  /** @deprecated use availability_enum instead */
  is_boutique: Scalars['Boolean']['output'];
  limited_trunkshow_data: Array<LimitedTrunkshowData>;
  looks: LookConnection;
  master: Scalars['Boolean']['output'];
  master_variant_id: Maybe<Scalars['Int']['output']>;
  master_variants_data: VariantData;
  name: Scalars['String']['output'];
  new_arrival_on_i: Scalars['Int']['output'];
  objectid: Scalars['String']['output'];
  order_limit: Maybe<Scalars['Int']['output']>;
  other_variants_data: Array<VariantData>;
  /** @deprecated use looks instead */
  paginated_looks: LookConnection;
  /** @deprecated use trunkshows instead */
  paginated_trunkshows: TrunkshowConnection;
  payment_type: Maybe<Scalars['String']['output']>;
  popularity: Scalars['Float']['output'];
  primary_look_id: Maybe<Scalars['Int']['output']>;
  product_id: Scalars['Int']['output'];
  queryid: Scalars['String']['output'];
  recency_bucket: Scalars['Int']['output'];
  recommendation_looks: Array<Look>;
  restricted: Scalars['Boolean']['output'];
  sales_volume_bucket: Scalars['Int']['output'];
  score: Maybe<Scalars['Int']['output']>;
  shipping_restrictions: Scalars['String']['output'];
  shop_attributes: Array<Scalars['String']['output']>;
  size_equivalents: Array<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  subcategory: Array<Scalars['String']['output']>;
  tag: Maybe<Scalars['String']['output']>;
  total_views: Scalars['Int']['output'];
  total_views_bucket: Scalars['Int']['output'];
  trunkshow_private_until: Scalars['Int']['output'];
  trunkshows: TrunkshowConnection;
  /** @deprecated use __typename instead */
  type: Scalars['String']['output'];
  unit_sales_bucket: Scalars['Int']['output'];
  variant_ids: Array<Scalars['Int']['output']>;
  vertical: Vertical;
  videos: Array<VariantVideo>;
};


export type VariantlooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type Variantpaginated_looksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type Variantpaginated_trunkshowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type VarianttrunkshowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type VariantConnection = {
  __typename: 'VariantConnection';
  /** @deprecated use variants instead */
  edges: Array<VariantEdge>;
  /** @deprecated use pagination instead */
  pageInfo: PageInfo;
  pagination: PaginationInfo;
  variants: Array<Maybe<Variant>>;
};

export type VariantData = {
  __typename: 'VariantData';
  alternate_image_urls: Array<VariantImageUrls>;
  /** @deprecated this isn't supported anymore */
  badges: Array<Scalars['String']['output']>;
  can_sell: Scalars['Boolean']['output'];
  collections: Array<Scalars['String']['output']>;
  color: Maybe<Scalars['String']['output']>;
  color_swatch_image_url: Maybe<Scalars['String']['output']>;
  coming_soon: Scalars['Boolean']['output'];
  custom_color_name: Maybe<Scalars['String']['output']>;
  custom_color_value: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventory: Array<Maybe<Inventory>>;
  label: Scalars['String']['output'];
  /** @deprecated this isn't supported anymore */
  mapped_color: Maybe<Scalars['String']['output']>;
  pay_in_full: Scalars['Boolean']['output'];
  prices: VariantPrice;
  primary_image_urls: VariantImageUrls;
  process_delivery_dates: VariantDelivery;
  /** @deprecated use return_policy_enum instead */
  return_policy: ReturnPolicy;
  return_policy_enum: ReturnPolicyV2;
  slug: Scalars['String']['output'];
  sold_out: Scalars['Boolean']['output'];
};


export type VariantDatapricesArgs = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  deposit_rate?: InputMaybe<Scalars['Float']['input']>;
  without_vat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VariantDelivery = {
  __typename: 'VariantDelivery';
  delivery_ends_on: Maybe<Scalars['String']['output']>;
  delivery_starts_on: Maybe<Scalars['String']['output']>;
};

export type VariantEdge = {
  __typename: 'VariantEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Maybe<Variant>;
};

export type VariantImageUrls = {
  __typename: 'VariantImageUrls';
  key: Maybe<Scalars['String']['output']>;
  large: Scalars['String']['output'];
  low: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  medium_large: Scalars['String']['output'];
  medium_low: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  small: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export type VariantPrice = {
  __typename: 'VariantPrice';
  currency: Scalars['String']['output'];
  current_price: PriceDetails;
  deposit_price: Maybe<PriceDetails>;
  original_price: PriceDetails;
  vat: PriceDetails;
};

export type VariantVideo = {
  __typename: 'VariantVideo';
  has_audio: Scalars['Boolean']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum Vertical {
  BEAUTY = 'BEAUTY',
  HOME = 'HOME',
  KIDS = 'KIDS',
  MEN = 'MEN',
  WOMEN = 'WOMEN'
}

export type VideoPumoModule = {
  __typename: 'VideoPumoModule';
  id: Scalars['Int']['output'];
  modelId: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  slides: Array<Slide>;
  video: EditorialVideo;
};
